
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dla-mieszkanca",
      function () {
        return require("private-next-pages/dla-mieszkanca/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dla-mieszkanca"])
      });
    }
  